// Autogenerated file
export const distributionBidOptionsEnum = {
    HasTemperatureProfile: "HasTemperatureProfile",
    HasUploadedFile: "HasUploadedFile",
    IsPreBid: "IsPreBid",
    IsShippingOrder: "IsShippingOrder",
};
export const distributionBidOptions = [
    { label: "Температурный режим", value: "HasTemperatureProfile", intValue: 1 },
    { label: "В заказ загружен файл(ы)", value: "HasUploadedFile", intValue: 2 },
    { label: "Предзаявка", value: "IsPreBid", intValue: 4 },
    { label: "Создано на основе Электронной Заказ-Заявки", value: "IsShippingOrder", intValue: 8 },
];
